import * as apiValues from '../constants/apiValues';
import * as pageOverallMapActions from '../actions/pageOverallMapActions';
import DocumentTitle from './DocumentTitle';
import MBreadcrumbs from './MBreadcrumbs';
import OverallMap from './OverallMap';
import PageBase from './PageBase';
import PropTypes from 'prop-types';
import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


class PageOverallMap extends React.Component{
  componentDidMount(){
    this.props.actions.initPageOverallMap();
  }


  renderBreadcrumbs(){
    let mBreadcrumbs = {
      pageChain: [
        {browserTitle: 'Home', slug: ''},
        {browserTitle: 'Maps', slug: '#'},
      ],
    };

    return (<MBreadcrumbs className="coupling coupling--full-centered" mBreadcrumbs={mBreadcrumbs}/>);
  }

  renderMapContent(){
    const {page} = this.props;

    if(page.isLoading){
      return (<p className="coupling coupling--centered-thin">Loading map configuration…</p>);
    }

    if(page.error){
      return (
        <p className="coupling coupling--centered-thin" role="alert">
          Unable to load map configuration. Please try again later.
        </p>
      );
    }

    if(!page.mapTabs || page.mapTabs.length === 0){
      return (
        <p className="coupling coupling--centered-thin" role="alert">
          Map configuration is not available.
        </p>
      );
    }

    return (
      <OverallMap location={this.props.location}
                  mode={'overall'}
                  tabs={page.mapTabs}/>
    );
  }

  render(){
    return (
      <PageBase>
        <DocumentTitle title={apiValues.buildTitle('Overall Map & Data')}/>
        {this.renderBreadcrumbs()}
        {this.renderMapContent()}
      </PageBase>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    page: state.page,
  }),
  (dispatch) => ({
    actions: bindActionCreators(pageOverallMapActions, dispatch),
  }),
)(PageOverallMap));


PageOverallMap.propTypes = {
  actions: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object.isRequired,
  page: PropTypes.object,
};
